import { render, staticRenderFns } from "./VideoCarousel.vue?vue&type=template&id=8f63a984&"
import script from "./VideoCarousel.vue?vue&type=script&lang=js&"
export * from "./VideoCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VideoCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports